import { withProps } from 'recompose'
import { Router } from 'react-router-dom'

import history from 'src/history'

export default withProps(() => ({ history }))(Router)
